import { takeEvery, call, put, all, fork } from 'redux-saga/effects';
import { GET_COOKIES, actionCreators as actionCreatorsCookies } from './action';

function* onGetCookiesSaga() {
    try {
      // call to api
      const response = yield call(fetch, 'http://localhost:8080/cookies-policy');
      const cookiesData = yield response.json();
      // put response to store
      yield put(actionCreatorsCookies.putCookies(cookiesData));
    }
    catch(error) {
      yield put(actionCreators.putAgreement(null));
    }
  }

function* getCookiesSaga() {
	yield takeEvery(GET_COOKIES, onGetCookiesSaga);
}

export function* cookiesSaga() {
	yield all([fork(getCookiesSaga)]);
}